"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _AccountsDropdownComponent = _interopRequireDefault(require("./AccountsDropdownComponent"));
var _userActions = require("../../redux/actions/userActions");
var _selectors = require("../../redux/margin/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var selectedAccountId = state.user.selectedAccountId;
  var accounts = (0, _selectors.accountsSelector)(state);
  var selectedAccount = accounts.find(function (account) {
    return account.AccountId === selectedAccountId;
  });
  if (!selectedAccount) {
    selectedAccount = (0, _selectors.defaultAccountSelector)(state);
  }
  return {
    accounts: accounts,
    selectedAccount: selectedAccount
  };
};
var mapDispatchToProps = {
  selectAccount: _userActions.selectAccount
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(_AccountsDropdownComponent["default"]));